<template>
  <div>
    <el-form :model="queryForm" :inline="true">
      <el-row>
        <el-col :span="6">
          <el-form-item label="患儿姓名" prop="childName">
            <el-input type="text" v-model="queryForm.childName" size="small" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="费用编号" prop="outlayId">
            <el-input type="text" v-model="queryForm.outlayId" size="small" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <SearchButton @search="loadData" @reset="resetSearchForm" @expand="e => expand = e"></SearchButton>
        </el-col>
      </el-row>
      <el-row v-if="expand">
        <el-col :span="6">
          <el-form-item label="申请时间" prop="helpQuota">
            <el-date-picker
              v-model="queryForm.helpTimeRange"
              type="daterange"
              size="small"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="关联协议" prop="outlayId">
            <el-input type="text" v-model="queryForm.protocolId" size="small" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      v-loading="loading"
      :data="tableData"
      style="width: 100%"
      height='calc(100vh - 285px)'>
      <el-table-column key="outlayId" prop="outlayId" label="费用编号" width="150" style="font-size: 14px;">
        <template slot-scope="scope">
          <span v-if="scope.row.outlayStatus > 0" class="link" @click="outlayFillIn(scope.row)">{{scope.row.outlayId}}</span>
          <span v-else class="link" @click="outlayFillIn(scope.row)">{{scope.row.outlayId}}</span>
        </template>
      </el-table-column>
      <el-table-column key="beginTime" v-if="['todo'].indexOf(active) < 0" prop="beginTime" label="提交时间" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.beginTime ? parseTime(scope.row.beginTime, '{y}-{m}-{d}') : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column key="childName" prop="childName" label="患儿姓名" width="110">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.childName"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column key="hospitalName" v-if="isHospital==='false'"   width="140"   label="救助医院">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.hospitalName"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column key="beforeDiseasesName" prop="beforeDiseasesName" label="病种">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.afterDiseasesName || scope.row.beforeDiseasesName"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column key="curStages" prop="curStages" align="center" label="期次" width="60">
        <template slot-scope="scope">
          {{scope.row.curStages}}/{{scope.row.initialProject == 'AY1002' ? '-' : (scope.row.totalStages || '-')}}
        </template>
      </el-table-column>
      <el-table-column key="birthday" prop="birthday" label="出生日期" width="100"></el-table-column>
      <el-table-column key="sex" prop="sex" width="50" label="性别">
        <template slot-scope="scope">
          {{scope.row.sex == 1 ? '男' : scope.row.sex == 0 ? '女' : '未知'}}
        </template>
      </el-table-column>
      <el-table-column key="checkTime" prop="checkTime" label="检查时间" width="100">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.checkTime, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column key="billCount" prop="billCount" label="发票张数" width="80" align="right">
        <template slot-scope="scope">
          {{scope.row.billCount == 0 ? 0 : (scope.row.billCount || '-')}}
        </template>
      </el-table-column>
      <el-table-column key="checkOutlay" prop="checkOutlay" label="检查费用" width="110" align="right">
        <template slot-scope="scope">
          {{scope.row.checkOutlay == 0 ? parseFloat(0).toFixed(2) : (scope.row.checkOutlay ? parseFloat(scope.row.checkOutlay).toFixed(2) : '-')}}
        </template>
      </el-table-column>
      <el-table-column key="helpAmount" prop="helpAmount" label="救助费用" width="110" align="right">
        <template slot-scope="scope">
          {{scope.row.helpAmount == 0 ? parseFloat(0).toFixed(2) : (scope.row.helpAmount ? parseFloat(scope.row.helpAmount).toFixed(2) : '-')}}
        </template>
      </el-table-column>
      <el-table-column key="outlayStatusName" prop="outlayStatusName" label="费用状态" width="80"></el-table-column>
      <el-table-column key="protocolId" v-if="active == 'done'" prop="protocolId" label="关联协议" width="170">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.protocolId">{{scope.row.protocolId || '-'}}</TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column key="helpTime" prop="helpTime" label="申请时间" width="110">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.helpTime, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column key="helpApprTime" prop="helpApprTime" label="审核时间" width="110">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.helpApprTime, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column key="options" width="110" fixed="right" label="操作" v-if="active == 'todo' || active == 'rollback'">
        <template slot-scope="scope">
          <el-button v-if="[0, 2].indexOf(scope.row.outlayStatus) > -1" plain type="primary" size="mini" @click="outlayFillIn(scope.row)">费用填写</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pageination
      @sizeChange="handleSizeChange"
      @currentChange="handleCurrentChange"
      :currentPage="queryParams.pageNO"
      :total="total">
    </Pageination>
    <CheckOutlayDialog :dialogVisible.sync="dailogVisible" v-if="dailogVisible" :rowData="rowData" :recordId="rowData.outlayId" @success="formSaveSuccess"></CheckOutlayDialog>
  </div>
</template>

<script>
import { getOutlayDataListByCond } from "@/util/api.js";
import HospitalSelect from "@/components/business/HospitalSelect";
import DiseaseCascader from "@/components/business/DiseaseCascader";
import TableCellWordBreak from "@/components/business/TableCellWordBreak"
import SearchButton from "@/components/business/SearchButton";
import Pageination from "@/components/business/Pageination";

import CheckOutlayDialog from "./CheckOutlayDialog";
export default {
  components: {
    HospitalSelect,
    TableCellWordBreak,
    DiseaseCascader,
    CheckOutlayDialog,
    SearchButton,
    Pageination
  },
  props: {
    active: {
      type: String,
      default: 'todo'
    }
  },
  data() {
    let isHospitalRole = this.isHospital();
    return {
      isHospitalRole: isHospitalRole,
      loading: false,
      isHospital:'false',
      expand: false,
      queryForm: {},
      queryParams: {
        pageNO: 1,
        pageSize: 10,
        searchCond: {}
      },
      defaultSearchCond: {},
      dailogVisible: false,
      tableData: [],
      rowData: {},
      total: 0
    };
  },
  watch: {
    active (val) {
      this.queryParams.pageNO = 1;
      this.initDefaultSearchCond();
      this.loadData()
    },
    $route(to,from){
      this.loadData();
    }
  },
  mounted () {
    this.queryParams.pageNO = 1;
    this.isHospital = window.localStorage.getItem("hospAccount")
    this.initDefaultSearchCond();
    this.loadData();
  },
  methods: {
    initDefaultSearchCond () {
      // 费用类型：1=治疗费用，2=检查费用
      this.defaultSearchCond.outlayType = 2;
      this.defaultSearchCond.isTimeout = 0;
      if (this.active == 'todo') {
        this.defaultSearchCond.outlayStatus = 0;
      } else if (this.active == 'done') {
        this.defaultSearchCond.outlayStatus = 1;
      } else if (this.active == 'rollback') {
        this.defaultSearchCond.outlayStatus = 2;
      } else if (this.active == 'timeout') {
        this.defaultSearchCond.outlayStatus = null;
        this.defaultSearchCond.isTimeout = 1;
      }
    },
    loadData () {
      this.loading = true
      if (this.queryForm.helpTimeRange && this.queryForm.helpTimeRange.length > 1) {
        this.queryForm.helpTimeBegin = this.queryForm.helpTimeRange[0];
        this.queryForm.helpTimeEnd = this.queryForm.helpTimeRange[1];
      }
      this.queryParams.searchCond = Object.assign({}, this.defaultSearchCond, this.queryForm);
      this.queryParams.searchCond.applyType = 1;
      getOutlayDataListByCond(this.queryParams).then(res => {
        this.tableData = res.responseData.modelData;
        this.total = res.responseData.total;
        this.loading = false
      })
    },
    resetSearchForm () {
      this.queryForm = {}
      this.loadData()
    },
    outlayFillIn(row) {
      this.rowData = row
      this.dailogVisible = true
    },
    formSaveSuccess () {
      this.loadData();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.queryParams.pageNO = val
      this.loadData()
    },
    openScreenFun() {
      this.openScreen1 = !this.openScreen1;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './../../../common/form.scss';
</style>



// WEBPACK FOOTER //
// src/pages/outlay/check/CheckOutlayTable.vue